import type { Tournament } from './components/FeaturedEventCard';

// Mock events for the hub prototype — swapped for the tournaments API later.
// 'seasonal' = the featured card (Weekend League), 'upcoming' rows = announced
// events, 'ended' rows = past events with their champion.
export const MOCK_EVENTS: Tournament[] = [
  {
    id: 'weekend-league',
    name: 'Weekend League',
    type: 'seasonal',
    prizePool: 'Setanta + EA FC 26',
    entryCoins: 0,
    minRank: 0,
    minRankTier: 'Bench',
    participants: 1834,
    maxParticipants: 4096,
    endsIn: '2d 14h',
    status: 'active',
    rewards: {
      first: '6 months Setanta Sports + EA FC 26',
      second: '3 months Setanta + FC Points',
      third: '1 month Setanta + FC Points',
    },
  },
  {
    id: 'season-event-aug',
    name: 'Season Event',
    type: 'weekly',
    prizePool: '50K Coins',
    entryCoins: 0,
    minRank: 1200,
    minRankTier: 'Rotation',
    participants: 312,
    maxParticipants: 2048,
    endsIn: 'Aug 1',
    status: 'upcoming',
    rewards: {
      first: '25,000 coins',
      second: '15,000 coins',
      third: '10,000 coins',
    },
  },
  {
    id: 'wl-2026-07-24',
    name: 'Weekend League',
    type: 'weekly',
    prizePool: 'Setanta + EA FC 26',
    entryCoins: 0,
    minRank: 0,
    minRankTier: 'Bench',
    participants: 2411,
    maxParticipants: 4096,
    endsIn: 'Jul 24–26',
    status: 'ended',
    champion: 'Kvaro7',
    rewards: {
      first: '6 months Setanta Sports + EA FC 26',
      second: '3 months Setanta + FC Points',
      third: '1 month Setanta + FC Points',
    },
  },
  {
    id: 'wl-2026-07-17',
    name: 'Weekend League',
    type: 'weekly',
    prizePool: 'Setanta + EA FC 26',
    entryCoins: 0,
    minRank: 0,
    minRankTier: 'Bench',
    participants: 1980,
    maxParticipants: 4096,
    endsIn: 'Jul 17–19',
    status: 'ended',
    champion: 'GigaBrain',
    rewards: {
      first: '6 months Setanta Sports + EA FC 26',
      second: '3 months Setanta + FC Points',
      third: '1 month Setanta + FC Points',
    },
  },
  {
    id: 'summer-cup-2026',
    name: 'Summer Cup',
    type: 'monthly',
    prizePool: '100K Coins',
    entryCoins: 500,
    minRank: 0,
    minRankTier: 'Bench',
    participants: 4096,
    maxParticipants: 4096,
    endsIn: 'Jun 26–28',
    status: 'ended',
    champion: 'DerbyKing',
    rewards: {
      first: '50,000 coins',
      second: '30,000 coins',
      third: '20,000 coins',
    },
  },
];
